import { Food, ResponseFoodsProps } from '../../../types/foods/Food';

export const LIST_FOODS = 'LIST_FOODS';
export const ADD_FOOD = 'ADD_FOOD';
export const DELETE_FOOD = 'DELETE_FOOD';
export const UPDATE_FOOD = 'UPDATE_FOOD';
export const UPLOAD_IMAGE_FOOD = 'UPLOAD_IMAGE_FOOD';
export const GET_FOODS = 'GET_FOODS';
export const RESET_FOODS_STATE = 'RESET_FOODS_STATE';

interface ActionListFoods {
  type: typeof LIST_FOODS;
  payload: ResponseFoodsProps;
}

interface ActionAddFoods {
  type: typeof ADD_FOOD;
  payload: Food;
}

interface ActionDeleteFoods {
  type: typeof DELETE_FOOD;
  payload: string;
}
interface ActionUpdateFoods {
  type: typeof UPDATE_FOOD;
  payload: Food;
}

interface ActionUploadImageFood {
  type: typeof UPLOAD_IMAGE_FOOD;
  payload: Food;
}

interface ActionGetFoods {
  type: typeof GET_FOODS;
  payload: Food[];
}

export interface ActionResetFoodsState {
  type: typeof RESET_FOODS_STATE;
}

export type TypesActionsFoods =
  | ActionListFoods
  | ActionAddFoods
  | ActionDeleteFoods
  | ActionUpdateFoods
  | ActionUploadImageFood
  | ActionGetFoods
  | ActionResetFoodsState;
